import React, { useState } from 'react'
import AdminLayout from '../../components/admin/AdminLayout'
import { useAuth } from '../../context/AuthContext'
import { API_BASE } from '../../utils/api'
import { useNavigate } from 'react-router-dom'

export default function AdminAddPropertyType() {
    const { token } = useAuth()
    const navigate = useNavigate()
    const [name, setName] = useState('')
    const [saving, setSaving] = useState(false)

    const handleSave = async () => {
        if (!name) return alert('Name required')
        setSaving(true)
        try {
            await fetch(`${API_BASE}/property-types`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ name }) })
            navigate('/admin-property-types')
        } catch (err) { console.error(err) } finally { setSaving(false) }
    }

    return (
        <AdminLayout>
            <div className="mb-6">
                <h1 className="text-2xl font-bold">Add Property Type</h1>
            </div>
            <div className="bg-white p-6 rounded-md">
                <label className="block mb-2 font-bold">Name</label>
                <input value={name} onChange={e => setName(e.target.value)} className="w-full p-3 border rounded mb-4" />
                <div className="flex gap-2">
                     <button className="px-5 py-2 bg-white border-2 border-[#05144b] text-[#05144b] hover:bg-blue-50 rounded font-bold transition-all shadow-md active:scale-95" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                    <button className="px-5 py-2 border rounded" onClick={() => navigate('/admin-property-types')}>Cancel</button>
                </div>
            </div>
        </AdminLayout>
    )
}
